import React from "react";
import { Helmet } from "react-helmet";
import GroupSubNav from "../../components/layout/GroupSubNav";
import HeaderNavigation from "../../components/layout/HeaderNavigation";
import PodcastCtaSection from "./components/PodcastCtaSection";
import PodcastEpisodeLibrarySection from "./components/PodcastEpisodeLibrarySection";
import PodcastFeaturedSection from "./components/PodcastFeaturedSection";
import PodcastHeaderSection from "./components/PodcastHeaderSection";
import SiteFooter from "../../components/layout/SiteFooter";

const Podcast = () => {
  return (
    <div>
      <Helmet>
        <title>Utiva | Podcast</title>
        <meta
          name="description"
          content="The Utiva Podcast: conversations that make a career in technology feel more possible, with technology experts and professionals sharing the experience behind meaningful growth."
        />
        <meta property="og:title" content="The Utiva Podcast" />
        <meta
          property="og:description"
          content="Honest conversations with people doing the work."
        />
        <meta property="og:url" content={window.location.href} />
        <meta property="og:type" content="website" />
      </Helmet>

      <header className="w-full relative">
        <HeaderNavigation />
      </header>
      <GroupSubNav />

      <main>
        <PodcastHeaderSection />
        <PodcastFeaturedSection />
        <PodcastEpisodeLibrarySection />
        <PodcastCtaSection />
      </main>

      <SiteFooter />
    </div>
  );
};

export default Podcast;
